import React, { useState, useCallback, useEffect } from "react";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Experiences } from "../components/Experiences";
import { BookingModal } from "../components/BookingModal";
import { Footer } from "../components/Footer";
import { Toaster } from "../components/ui/sonner";
import { fetchExperiences, createBooking, seedData } from "../api";
import { toast } from "sonner";

export default function HomePage() {
  const [experiences, setExperiences] = useState([]);
  const [selectedExperience, setSelectedExperience] = useState(null);
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadExperiences();
  }, []);

  const loadExperiences = async () => {
    try {
      let data = await fetchExperiences();
      if (data.length === 0) {
        await seedData();
        data = await fetchExperiences();
      }
      setExperiences(data);
    } catch (err) {
      console.error("Failed to load experiences:", err);
      toast.error("Failed to load experiences");
    } finally {
      setLoading(false);
    }
  };

  const scrollTo = useCallback((id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  }, []);

  const handleBookNow = useCallback((experience) => {
    setSelectedExperience(experience);
    setIsBookingOpen(true);
  }, []);

  const handleBookingSubmit = async (bookingData) => {
    try {
      const result = await createBooking(bookingData);
      loadExperiences();
      return result;
    } catch (err) {
      const msg = err.response?.data?.detail || "Booking failed";
      toast.error(msg);
      throw err;
    }
  };

  return (
    <div style={{ background: "var(--np-bg)", minHeight: "100vh" }}>
      <Header onScrollTo={scrollTo} />

      {/* Experiences section is now the hero/landing */}
      {loading ? (
        <section className="bg-experiences-gradient py-32 flex items-center justify-center pt-28">
          <div className="w-10 h-10 border-2 rounded-full animate-spin" style={{ borderColor: "var(--np-accent-30)", borderTopColor: "var(--np-accent)" }} />
        </section>
      ) : (
        <div className="pt-20">
          <Experiences experiences={experiences} onBookNow={handleBookNow} />
        </div>
      )}

      {/* Hero/About section is now the second page */}
      <Hero onViewExperiences={() => scrollTo("experiences")} />

      <Footer />

      <BookingModal
        experience={selectedExperience}
        isOpen={isBookingOpen}
        onClose={() => setIsBookingOpen(false)}
        onBookingSubmit={handleBookingSubmit}
      />

      <Toaster position="top-center" />

      {/* Sticky Mobile CTA */}
      <div
        className="fixed bottom-0 left-0 right-0 p-4 backdrop-blur-sm md:hidden z-40"
        style={{
          background: "var(--np-overlay)",
          borderTop: "1px solid var(--np-border)",
        }}
      >
        <button
          onClick={() => scrollTo("experiences")}
          className="w-full py-4 text-lg font-medium rounded-full"
          style={{ background: "var(--np-cta)", color: "var(--np-cta-text)" }}
        >
          View Experiences
        </button>
      </div>
    </div>
  );
}
